/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export enum PrintProofStatusEnum {
    processing = "processing",
    pending_review = "pending_review",
    reviewed = "reviewed",
    visual_designer_approved = "visual_designer_approved"
}

export type PrintProofStatus = PrintProofStatusEnum;